<!-- Contenedor Principal -->
<div class="max-w-2xl py-3">
  <!-- Alerta de Compatibilidad -->
  @if (!isBrowser()) {
    <div class="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
      <div class="flex gap-3">
        <i class="bi bi-exclamation-triangle text-yellow-600 text-lg shrink-0"></i>
        <div>
          <p class="font-semibold text-yellow-900">No disponible en servidor</p>
          <p class="text-sm text-yellow-700">
            Esta configuración solo funciona desde el navegador cliente
          </p>
        </div>
      </div>
    </div>
  }

  <!-- Alerta de Dispositivo -->
  @if (isBrowser() && !isDesktop()) {
    <div class="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <div class="flex gap-3">
        <i class="bi bi-info-circle text-blue-600 text-lg shrink-0"></i>
        <div>
          <p class="font-semibold text-blue-900">Dispositivo no soportado</p>
          <p class="text-sm text-blue-700">
            Esta función solo está disponible en computadoras de escritorio. Tablets y móviles no
            pueden imprimir
          </p>
        </div>
      </div>
    </div>
  }

  <!-- Alerta QZ Tray no disponible -->
  @if (
    isBrowser() && isDesktop() && this.impresoras() !== null && this.impresoras()?.length === 0
  ) {
    <div class="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
      <div class="flex gap-3">
        <i class="bi bi-exclamation-circle text-red-600 text-lg shrink-0"></i>
        <div>
          <p class="font-semibold text-red-900">QZ Tray no detectado o impresora no disponible</p>
          <p class="text-sm text-red-700 mb-3">
            Para usar impresión directa necesitas instalar QZ Tray en tu computadora
          </p>
          <a
            href="https://www.qz.io/download/"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded-lg hover:bg-red-700 transition"
          >
            <i class="bi bi-download"></i>
            Descargar QZ Tray
          </a>
        </div>
      </div>
    </div>
  }

  <!-- Contenido Principal (solo si está disponible) -->
  @if (puedeConfigurar()) {
    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      <!-- Loading Overlay -->
      @if (impresoras() === null) {
        <div
          class="absolute inset-0 bg-white/50 backdrop-blur-sm flex items-center justify-center rounded-2xl z-10"
        >
          <div class="text-center">
            <div
              class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 mb-4"
            >
              <i class="bi bi-arrow-repeat text-blue-600 text-lg animate-spin"></i>
            </div>
            <p class="text-slate-600 font-medium">Cargando...</p>
          </div>
        </div>
      }

      <div class="relative p-6 sm:p-8">
        <!-- Sección: Estado Actual -->
        <div class="mb-8 pb-8 border-b border-slate-200">
          <h2 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
            <i class="bi bi-info-circle text-blue-600"></i>
            Estado Actual
          </h2>

          @if (tieneConfiguracion()) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="p-4 bg-green-50 rounded-lg border border-green-200">
                <p class="text-sm text-green-700 font-medium mb-1">Nombre de Impresora</p>
                <p class="text-lg font-bold text-green-900">{{ configActual()?.aliasImpresora }}</p>
              </div>
              <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <p class="text-sm text-slate-600 font-medium mb-1">Dispositivo: Nombre Técnico</p>
                <p class="text-lg font-bold text-slate-900 font-mono">
                  {{ configActual()?.printerName }}
                </p>
              </div>
            </div>
          } @else {
            <div class="p-4 bg-amber-50 rounded-lg border border-amber-200">
              <p class="text-sm text-amber-700">
                <i class="bi bi-exclamation-triangle mr-2"></i>
                No hay configuración guardada
              </p>
            </div>
          }
        </div>

        <!-- Sección: Nombre de la Impresora -->
        <div class="mb-8 pb-8 border-b border-slate-200">
          <h2 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
            <i class="bi bi-tag text-blue-600"></i>
            Nombre de la Impresora
          </h2>
          <p class="text-sm text-slate-600 mb-4">
            Elige un nombre identificable para esta impresora (ej: "Impresora Cocina", "Caja 1",
            etc.)
          </p>
          <input
            type="text"
            [(ngModel)]="aliasImpresora"
            placeholder="Ej: Impresora Cocina, Caja 1, Punto de Venta..."
            [disabled]="impresoras() === null"
            class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-slate-100 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Sección: Ancho del Papel -->
        <div class="mb-8 pb-8 border-b border-slate-200">
          <h2 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
            <i class="bi bi-rulers text-blue-600"></i>
            Ancho del Papel (mm)
          </h2>
          <p class="text-sm text-slate-600 mb-4">
            Indica el ancho del papel en milímetros. Valores comunes: 58 o 80 mm.
          </p>
          <input
            type="number"
            min="40"
            max="120"
            step="1"
            [(ngModel)]="width_mm_Impresora"
            placeholder="Ej: 80"
            [disabled]="impresoras() === null"
            class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-slate-100 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Sección: Seleccionar Impresora -->
        <div class="mb-8">
          <h2 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
            <i class="bi bi-printer text-blue-600"></i>
            Seleccionar Impresora
          </h2>

          @if (impresoras() !== null && impresoras()!.length > 0) {
            <div class="space-y-2">
              @for (impresora of impresoras(); track impresora) {
                <button
                  (click)="seleccionarImpresora(impresora)"
                  type="button"
                  [class.ring-2]="impresoraSeleccionada() === impresora"
                  [class.ring-blue-500]="impresoraSeleccionada() === impresora"
                  [class.bg-blue-50]="impresoraSeleccionada() === impresora"
                  class="w-full text-left p-4 border border-slate-300 rounded-lg hover:border-blue-400 hover:bg-slate-50 transition cursor-pointer"
                >
                  <div class="flex items-center gap-3">
                    <div
                      [class.bg-blue-600]="impresoraSeleccionada() === impresora"
                      [class.border-blue-600]="impresoraSeleccionada() === impresora"
                      [class.bg-white]="impresoraSeleccionada() !== impresora"
                      [class.border-slate-300]="impresoraSeleccionada() !== impresora"
                      class="w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0"
                    >
                      @if (impresoraSeleccionada() === impresora) {
                        <i class="bi bi-check text-white text-sm"></i>
                      }
                    </div>
                    <div>
                      <p class="font-semibold text-slate-900">{{ impresora }}</p>
                      @if (configActual()?.printerName === impresora) {
                        <p class="text-xs text-green-600 flex items-center gap-1 mt-1">
                          <i class="bi bi-check-circle-fill"></i>
                          Actualmente configurada
                        </p>
                      }
                    </div>
                  </div>
                </button>
              }
            </div>
          } @else {
            <div class="p-6 bg-slate-50 rounded-lg border border-slate-200 text-center">
              <i class="bi bi-search text-3xl text-slate-400 mb-2 block"></i>
              <p class="text-slate-600 font-medium">No se encontraron impresoras</p>
              <p class="text-sm text-slate-500 mt-1">
                Asegúrate de tener impresoras configuradas en tu sistema
              </p>
            </div>
          }
        </div>

        <!-- Sección: Acciones -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <button
            (click)="guardarConfiguracion()"
            [disabled]="!impresoraSeleccionada() || impresoras() === null"
            type="button"
            class="sm:col-span-2 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center justify-center gap-2"
          >
            <i class="bi bi-check-circle"></i>
            Guardar Configuración
          </button>

          <button
            (click)="testImpresion()"
            [disabled]="!tieneConfiguracion() || testPrintLoading()"
            type="button"
            class="px-4 py-3 bg-slate-200 text-slate-900 font-semibold rounded-lg hover:bg-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center justify-center gap-2"
          >
            @if (testPrintLoading()) {
              <i class="bi bi-arrow-repeat text-sm animate-spin"></i>
            } @else {
              <i class="bi bi-printer"></i>
            }
            Test
          </button>
        </div>

        <!-- Sección: Peligro -->
        @if (tieneConfiguracion()) {
          <div class="mt-8 pt-8 border-t border-slate-200">
            <div class="p-4 bg-red-50 rounded-lg border border-red-200">
              <p class="text-sm text-red-700 font-medium mb-3">
                <i class="bi bi-exclamation-triangle mr-2"></i>
                Se eliminará la configuración guardada y se perderá la conexión con esta impresora.
                Solo hazlo si estás seguro de querer eliminar esta configuración.
              </p>
              <button
                (click)="limpiarConfiguracion()"
                type="button"
                class="w-full px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded-lg hover:bg-red-700 transition"
              >
                <i class="bi bi-trash mr-2"></i>
                Eliminar Configuración
              </button>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Información de Ayuda -->
    <div class="mt-8 bg-blue-50 rounded-2xl p-6 border border-blue-200">
      <h3 class="font-semibold text-blue-900 mb-3 flex items-center gap-2">
        <i class="bi bi-lightbulb-fill"></i>
        ¿Cómo funciona?
      </h3>
      <ul class="space-y-2 text-sm text-blue-800">
        <li class="flex gap-3">
          <span class="font-bold text-blue-600 shrink-0">1.</span>
          <span>Instala QZ Tray en tu computadora desde el enlace anterior</span>
        </li>
        <li class="flex gap-3">
          <span class="font-bold text-blue-600 shrink-0">2.</span>
          <span>Selecciona tu impresora física de la lista anterior</span>
        </li>
        <li class="flex gap-3">
          <span class="font-bold text-blue-600 shrink-0">3.</span>
          <span>Haz clic en "Guardar Configuración" para almacenarla localmente</span>
        </li>
        <li class="flex gap-3">
          <span class="font-bold text-blue-600 shrink-0">4.</span>
          <span>
            El POS enviará automáticamente documentos a esta impresora a través de WebSockets
          </span>
        </li>
        <li class="flex gap-3">
          <span class="font-bold text-blue-600 shrink-0">5.</span>
          <span>Usa "Test" para verificar que la impresora responde correctamente</span>
        </li>
        <li class="flex gap-3">
          <span class="font-bold text-blue-600 shrink-0">6.</span>
          <span>
            Descarga el certificado digital para QZ Tray:
            <a
              href="/certs/digital-certificate.pem"
              download
              class="ml-1 inline-flex items-center gap-2 text-blue-700 font-semibold hover:text-blue-900"
            >
              <i class="bi bi-download"></i>
              Descargar certificado
            </a>
          </span>
        </li>
      </ul>
    </div>
  } @else if (isBrowser()) {
    <!-- Mensaje cuando no puede configurar pero está en navegador -->
    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
      <i class="bi bi-pc-display text-4xl text-slate-400 mb-4 block"></i>
      <p class="text-lg font-semibold text-slate-900 mb-2">
        Acceso no disponible desde este dispositivo
      </p>
      <p class="text-slate-600">
        Por favor, usa un navegador en tu computadora de escritorio con QZ Tray instalado
      </p>
    </div>
  }
</div>
